import { LearnersLoader } from './loader';
import routerUtility from 'utils/routerUtility';
import ModuleAccessCodes from '../../../../constants/moduleCodes';
import { get2bapLearnersModuleUrl, get2bapLearnersSummaryViewUrl } from './getUrls';
import { RouterRedirect } from '../../../../utils';
import { LearnersRouterHelper } from './helpers/LearnersRouterHelper';

export default {

  path: get2bapLearnersModuleUrl(),

  getIndexRoute(partialNextState, callback) {
    require.ensure([], () => {
      callback(new RouterRedirect(get2bapLearnersSummaryViewUrl()));
    });
  },

  getComponent(nextState, callback) {
    const error = routerUtility.getAccessError(ModuleAccessCodes.MODULE_2BAP);
    if (error) {
      callback(error);
      return;
    }

    LearnersLoader.load(callback);
  },

  getChildRoutes(partialNextState, callback) {
    require.ensure([], function (require) {
      callback(null, [
        {
          path: LearnersRouterHelper.SUMMARY_VIEW_PATH,
          component: require('./views/summaryView/LearnersSummaryViewPage').LearnersSummaryViewPage
        },
      ], '2bap-learners-chunk');
    });
  }

}
